import ScheduleIcon from '@material-ui/icons/Schedule';
import ScheduleCreate from './ScheduleCreate';
import ScheduleEdit from './ScheduleEdit';
import ScheduleList from './ScheduleList';
import ScheduleShow from './ScheduleShow';

const pages = {
    list: ScheduleList,
    create: ScheduleCreate,
    edit: ScheduleEdit,
    show: ScheduleShow,
    icon: ScheduleIcon,
};

export default pages;